import { css } from '@emotion/css';

export const buttonStyles = css`
  font-weight: 400;
`;

export const dateSelectionContainer = css`
  width: 30rem;
`;

export const activeDatePickerInput = css`
  border-color: var(--interactive-primary) !important;
`;

export const calendarContainerStyles = css`
  > div {
    height: unset;
  }
`;
